import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './popover-embed.module.scss';
import playBtn from './img/btn_play@2x.png';

const responsivePadding = {
  padding: '56.25% 0 0 0',
  position: 'relative',
};

const responsiveWrapper = {
  height: '100%',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
};

const embedStyle = {
  height: '100%',
  width: '100%',
};

class PopoverEmbed extends Component {
  componentDidMount() {
    const {_wq: wistia} = window;
    const {
      video: {hashed_id: id},
      setPlayFn,
    } = this.props;
    wistia.push({
      id,
      onReady: video => {
        this.video = video;
      },
    });
    if (setPlayFn) {
      setPlayFn(this.playVideo);
    }
  }

  playVideo = () => {
    if (this.video) {
      this.video.popover.showAndPlay();
    }
  };

  render() {
    const {className, video} = this.props;

    return (
      <div className={classNames(styles.PopoverEmbed, className)}>
        <div className={styles.PopoverEmbed__btn} onClick={this.playVideo}>
          <img alt="play video" src={playBtn} />
        </div>
        <div className="wistia_responsive_padding" style={responsivePadding}>
          <div className="wistia_responsive_wrapper" style={responsiveWrapper}>
            <div
              className={classNames(
                'playButton=false',
                'popover=true',
                'videoFoam=true',
                `wistia_embed wistia_async_${video.hashed_id}`
              )}
              style={embedStyle}
            />
          </div>
        </div>
      </div>
    );
  }
}

PopoverEmbed.propTypes = {
  className: PropTypes.string,
  setPlayFn: PropTypes.func,
  video: PropTypes.shape({
    hashed_id: PropTypes.string.isRequired,
    thumbnail: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default PopoverEmbed;



// WEBPACK FOOTER //
// ./src/components/videos/PopoverEmbed.js